import { useContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { andTheme } from '../../styles/theme'
import Navbar from '../navbar/navbar'
import hamburger from '../navbar/assets/hamburger.png'
import logo from './assets/logo.svg'
import logAnalyticsEvent from '../../utilities/firebase-analytics'
import {
  HeaderContainer,
  SignOut,
  DropDown,
  NavContainer,
  Logo,
  StyledNavLink,
  StyledSpan,
  ParentBanner
} from './header-styles'
import MobileMenuPanel from '../navbar/mobile-menu-panel'
import { LoginContext } from '../../contexts/login-context'
import { ApiContext } from '../../contexts/api-context'
import UserImage from './user-image'
import { MenuIcon } from '../navbar/navbar-styles'
import { MenuContext } from '../../contexts/menu-context'
import Banner from '../atoms/Banner/banner'

const Header = () => {
  const location = useLocation()
  const { handleAuth } = useContext(LoginContext)
  const { menuOpen, setMenuOpen } = useContext(MenuContext)
  const [isDesktop, setDesktop] = useState(window.innerWidth > andTheme.breakpoints.lg)

  const updateMedia = () => {
    setDesktop(window.innerWidth > andTheme.breakpoints.lg)
  }

  useEffect(() => {
    window.addEventListener('resize', updateMedia)
    return () => window.removeEventListener('resize', updateMedia)
  }, [])
  const { user } = useContext(LoginContext)
  const { userProfile } = useContext(ApiContext)
  const onClickSignOut = async () => {
    try {
      await handleAuth()
      logAnalyticsEvent('logout', {
        user: user?.email,
        team: userProfile?.team,
        default_location: userProfile?.businessUnit,
        page_title: 'Logout'
      })
    } catch (e) {
      if (e instanceof Error) {
        // eslint-disable-next-line no-console
        console.error(e.message)
      }
    }
  }

  return (
    <>
      {!isDesktop && <MobileMenuPanel signOutHandler={onClickSignOut} />}
      <ParentBanner>
        <Banner />
      </ParentBanner>
      <HeaderContainer>
        <Logo src={logo} alt="AND Space logo" />
        {isDesktop ? (
          <NavContainer>
            <Navbar />
            <SignOut>
              <UserImage />
              <DropDown>
                {location.pathname !== '/profile' && (
                  <StyledNavLink to="profile">My Profile</StyledNavLink>
                )}
                <StyledSpan onClick={onClickSignOut}>Sign out</StyledSpan>
              </DropDown>
            </SignOut>
          </NavContainer>
        ) : (
          <MenuIcon
            onClick={() => setMenuOpen(true)}
            src={hamburger}
            alt="hamburger"
            className={menuOpen ? 'hidden' : ''}
          />
        )}
      </HeaderContainer>
    </>
  )
}
export default Header
